<template>
    <div class="app-screen">
        <div class="top-panel global-offset">
            <div class="report">
                <div class="arrow"></div>
                <div class="info">
                    <p>Behavior Anomalies</p>

                    <div class="breadcrumbs-sc">
                        <span>Home</span> <i class="glyphicon glyphicon-menu-right"></i>
                        Behavior Anomalies
                    </div>
                </div>
            </div>
        </div>

        <div class="line"></div>
        <div class="app-body global-offset">
            <div class="risk-score-timeline">
                <div class="controls">
                    <img src="//img.netwrix.com/elements/onlineDemo/ui_icons/bars-icon-active.png" alt="">
                    <img src="//img.netwrix.com/elements/onlineDemo/ui_icons/torus-icon.png" alt="">
                </div>
                <div class="bars-cont">
                    <div class="title">
                        RISK SCORE TIMELINE
                    </div>
                    <div class="yaxis">
                        <div>600 <span>—</span></div>
                        <div>300 <span>—</span></div>
                        <div>0 <span>—</span></div>
                    </div>
                    <div class="bars">
                        <div v-for="(bar, index) in bars" :style="{'height': bar + 'px'}" class="bar" :key="index"></div>
                    </div>
                    <div class="xaxis">

                    </div>
                </div>
            </div>
            <div class="users-list">
                <div class="list-header">
                    <div>User</div>
                    <div>Risk score</div>
                    <div>Last alert time</div>
                </div>
                <div class="list-row" v-for="(user, index) in users" @dblclick="(isDblclickStep && user.clickable) ? $root.$emit(EVENT_NEXT_STEP) : ''" :key="index">
                    <div>{{user.name}}</div>
                    <div>{{user.risk_score}}</div>
                    <div>{{user.last_alert_time}}</div>
                </div>
            </div>
        </div>

        <div class="line"></div>

        <div class="bottom-block global-offset">
            <div class="btn white">Refresh</div>
        </div>
    </div>
</template>

<script>
  import {mapState} from 'vuex';

  import {EVENT_NEXT_STEP} from '@/constants';
  import spacers from '@/mixins/spacers';

  export default {
    name: "dashboard-screen-sc10-st2_5",
    mixins: [spacers],
    data() {
      return {
        currentLeftSpacer: 'spacer-risk-assessment-overview',
        currentRightSpacer: 'spacer-risk-assessment-overview',
        EVENT_NEXT_STEP: EVENT_NEXT_STEP,
        bars: [67, 64, 61, 67, 58, 57, 55, 57, 47, 61, 42, 62, 52, 64, 69, 67, 70, 69, 61, 64, 61, 81, 95, 99, 81, 99, 99, 108, 100, 62],
        users: [
          {
            name: 'ENTERPRISE\\T.Simpson',
            risk_score: 855,
            last_alert_time: '10/28/2018 12:16:21 PM',
            clickable: true,
          },
          {
            name: 'ENTERPRISE\\M.Gold',
            risk_score: 410,
            last_alert_time: '10/25/2018 5:07:28 AM',
          },
          {
            name: 'ENTERPRISE\\J.Rogers',
            risk_score: 320,
            last_alert_time: '10/28/2018 10:36:41 AM',
          },
          {
            name: 'ENTERPRISE\\P.Lewis',
            risk_score: 230,
            last_alert_time: '10/19/2018 11:44:32 PM',
          },
          {
            name: 'ENTERPRISE\\E.Walsh',
            risk_score: 225,
            last_alert_time: '10/4/2018 3:57:03 AM',
          },
          {
            name: 'ENTERPRISE\\P.Jefferson',
            risk_score: 180,
            last_alert_time: '10/13/2018 4:18:45 AM',
          },
          {
            name: 'ENTERPRISE\\P.Smith',
            risk_score: 140,
            last_alert_time: '10/4/2018 8:11:02 AM',
          },
          {
            name: 'ENTERPRISE\\J.Carter',
            risk_score: 50,
            last_alert_time: '10/1/2018 2:56:56 PM',
          },
          {
            name: 'ENTERPRISE\\M.Peterson',
            risk_score: 30,
            last_alert_time: '10/1/2018  1:14:22 PM',
          },
          {
            name: 'ENTERPRISE\\R.Gates',
            risk_score: 0,
            last_alert_time: '',
          },
        ],
        steps: {
          dblclickStep: 5,
        },
      };
    },
    computed: {
      ...mapState('guide', ['currentStep']),
      isDblclickStep() {
        return (this.currentStep === this.steps.dblclickStep);
      },
    },
  }
</script>

<style lang="less" scoped>
    @borderColor: #d5d5d5;

    .line {
        border-bottom: 1px solid @borderColor;
    }

    .app-screen {
        .top-panel {
            margin-bottom: 5px;
            text-align: center;
            position: relative;
            .report {
                text-align: left;

                .arrow,
                .info {
                    display: inline-block;
                    vertical-align: top;
                }

                .arrow {
                    width: 26px;
                    height: 26px;
                    background: url(//img.netwrix.com/elements/onlineDemo/ui_icons/arrow_back_ico.svg) 0 50% no-repeat;
                    margin-right: 12px;
                    cursor: pointer;
                }

                .info {
                    p {
                        font-size: 22px;
                        margin-bottom: 0;
                        color: #202020;
                    }

                    .breadcrumbs-sc {
                        color: #58595b;
                        font-size: 13px;
                        font-weight: 400;
                        line-height: 26px;

                        .glyphicon {
                            font-size: 12px;
                        }

                        span {
                            color: #0d71b9;
                        }
                    }
                }
            }
        }

        .app-body {
            .risk-score-timeline {
                margin-top: 32px;
                .controls {
                    width: 89px;
                    text-align: center;
                    display: inline-block;
                    img {
                        margin-bottom: 8px;
                    }
                }
                .bars-cont {
                    display: inline-block;
                    vertical-align: top;

                    .title {
                        color: #7b838a;
                        font-size: 13px;
                        font-weight: 600;
                        line-height: 0.7;
                        text-transform: uppercase;
                    }

                    .xaxis, .yaxis {
                        color: #61666b;
                        font-size: 13px;
                        font-weight: 400;
                        line-height: 20px;
                    }

                    .yaxis {
                        width: 41px;
                        display: inline-block;
                        text-align: right;
                        vertical-align: bottom;

                        & > div {
                            position: relative;
                            right: -5px;
                            span {
                                color: #dbdada;
                            }

                            &:nth-child(1) {
                                top: -58px;
                            }
                            &:nth-child(2) {
                                top: -24px;
                            }
                            &:nth-child(3) {
                                top: 8px;
                            }
                        }
                    }

                    .bars {
                        display: inline-block;
                        border-bottom: 1px solid #dbdada;
                        margin-top: 26px;
                        vertical-align: bottom;
                    }

                    .bar {
                        display: inline-block;
                        vertical-align: bottom;
                        width: 30px;
                        background-color: #7db2dd;
                        margin-left: 12px;
                        position: relative;
                        &:before {
                            content: '';
                            display: block;
                            position: absolute;
                            width: 1px;
                            height: 5px;
                            background-color: #dbdada;
                            bottom: -5px;
                            left: 50%;
                        }
                    }
                }
            }

            .users-list {
                width: 1429px;
                margin-top: 50px;
                margin-bottom: 32px;

                .cell-mixin {

                }

                .list-header {
                    font-size: 0;
                    & > div {
                        display: inline-block;
                        background-color: #d7effe;
                        height: 25px;
                        color: #202020;
                        font-size: 12px;
                        font-weight: 600;
                        line-height: 2.4;
                        padding: 0 7px;
                        margin-left: 2px;

                        &:nth-child(1) {
                            width: 647px;
                        }

                        &:nth-child(2) {
                            width: 320px;
                        }

                        &:nth-child(3) {
                            width: 456px;
                        }
                    }
                }

                .list-row {
                    font-size: 0;
                    height: 40px;
                    cursor: pointer;

                    & > div {
                        display: inline-block;
                        color: #202020;
                        font-size: 13px;
                        font-weight: 400;
                        padding: 9px 7px;
                        margin-left: 2px;

                        &:nth-child(1) {
                            width: 647px;
                            position: relative;

                            &:before {
                                content: '';
                                display: inline-block;
                                vertical-align: middle;
                                width: 12px;
                                height: 13px;
                                margin-right: 8px;
                                background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/user-list-icon.png');
                            }

                            &:after {
                                display: block;
                                position: absolute;
                                top: 9px;
                                right: 52px;
                                content: 'View Profile';
                                color: #0d70b8;
                            }
                        }

                        &:nth-child(2) {
                            width: 320px;
                        }

                        &:nth-child(3) {
                            width: 456px;
                        }
                    }
                }
            }
        }

        .bottom-block {
            padding-top: 9px;

            .btn {
                border-radius: 0;
                min-width: 100px;
                padding: 4px 0;

                margin-right: 2px;

                &.blue {
                    background-color: #1472bb;
                    color: #ffffff;
                }

                &.white {
                    color: #1472bb;
                    border: 1px solid #1472bb;
                }
            }
        }
    }
</style>